import ClearRounded from "@mui/icons-material/ClearRounded";
import SearchRounded from "@mui/icons-material/SearchRounded";
import styled from "styled-components";

import { ANIMATION, QUERIES, SPACING } from "../../../utils/constants";
import { IconButton } from "../../IconButton";

export const SearchIcon = styled(SearchRounded)`
  position: absolute;
  left: ${SPACING.sm + SPACING.xs}px;
  font-size: var(--text-lg) !important;
  color: var(--color-text-secondary);
  pointer-events: none;
  transition: color ${ANIMATION.duration.normal} ${ANIMATION.easing.easeOut};
`;

export const SearchWrapper = styled.div`
  position: relative;
  width: 100%;
  min-width: 0;
  display: flex;
  align-items: center;

  &:focus-within ${SearchIcon} {
    color: var(--color-primary);
  }
`;

export const Input = styled.input`
  width: 100%;
  min-height: 42px;
  padding: ${SPACING.sm + 2}px ${SPACING.xl}px ${SPACING.sm + 2}px
    ${SPACING.xl + SPACING.xs}px;
  border: 1px solid var(--color-border);
  border-radius: ${SPACING.sm}px;
  background: var(--color-card-background);
  color: var(--color-text-default);
  font-family: inherit;
  font-size: var(--text-base);
  transition:
    border-color ${ANIMATION.duration.normal} ${ANIMATION.easing.easeOut},
    box-shadow ${ANIMATION.duration.normal} ${ANIMATION.easing.easeOut};

  &::placeholder {
    color: var(--color-text-secondary);
  }

  &:hover:not(:disabled) {
    border-color: var(--color-primary);
  }

  &:focus {
    outline: none;
    border-color: var(--color-primary);
    box-shadow: var(--shadow-focus);
  }

  &:disabled {
    background: var(--color-background-disabled);
    color: var(--color-text-secondary);
    cursor: revert;
  }

  @media ${QUERIES.tabletAndDown} {
    font-size: var(--text-md);
  }
`;

export const ClearButton = styled(IconButton)`
  position: absolute;
  right: ${SPACING.xs}px;
`;

export const ClearIcon = styled(ClearRounded)``;
